import React, { Component } from 'react';
import { config } from '../../env_config/react-config';
import { connect } from 'react-redux';

const imageBaseUrl = config.medias;

/**
 * Loading Component
 * @function Loading
 * Displays the loader while downloading content
 * @return {div}
 */
const Loading = (props) => (
    <div className="loading-icon">
        <img src={imageBaseUrl + '/themes/custom/dlc/images/loading.gif'} alt={props.commonDetails.loading_text} width="100px" aria-label='Loading' aria-live='polite'/>
    </div>
)

export const mapStateToProps = state => ({
    commonDetails: state.commonReducer.commonDetails
});

export const mapDispatchToProps = (dispatch) => ({

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Loading);
